import React, { useState, useEffect, useContext } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import AppContext from '../../../../context/AppContext';

const RevenueChart = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [revenueData, setRevenueData] = useState([]);
  const { baseUrl } = useContext(AppContext);

 // NEW
  useEffect(() => {
    fetch(`${baseUrl}/admin/revenue-overview`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
        Accept: 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setRevenueData(Array.isArray(data) ? data : []))
      .catch(() => setRevenueData([]));
  }, []);

  const handleDownload = () => {
    let csvContent = "Month,Revenue\n";
    revenueData.forEach(row => {
      csvContent += `${row.month},${row.revenue}\n`;
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'revenue_overview.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    setShowMenu(false);
  };

  return (
    <>
      <div className="AdminSideDashboard__chartSection AdminSideDashboard--slideUp" style={{ animationDelay: '0.5s' }}>
        <div className="AdminSideDashboard__chartHeader">
          <h2 className="AdminSideDashboard__sectionTitle">Revenue Overview</h2>
          <div className="AdminSideDashboard__menuContainer">
            <button 
              className="AdminSideDashboard__menuBtn"
              onClick={() => setShowMenu(!showMenu)}
            >
              ⋯
            </button>
            {showMenu && (
              <div className="AdminSideDashboard__dropdownMenu AdminSideDashboard--fadeIn">
                <button 
                  className="AdminSideDashboard__menuItem"
                  onClick={handleDownload}
                >
                  <span className="AdminSideDashboard__menuIcon">📥</span>
                  Download Report
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="AdminSideDashboard__chart">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={revenueData}>
              <defs>
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#4ade80" stopOpacity={0.3}/>
                  <stop offset="95%" stopColor="#4ade80" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="month" stroke="#888" />
              <YAxis stroke="#888" />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: '#fff', 
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
              />
              <Line 
                type="monotone" 
                dataKey="revenue" 
                stroke="#4ade80" 
                strokeWidth={3}
                fill="url(#colorRevenue)"
                dot={{ fill: '#4ade80', strokeWidth: 2, r: 5 }}
                activeDot={{ r: 8 }}
                animationDuration={2000}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {showMenu && (
        <div 
          className="AdminSideDashboard__overlay"
          onClick={() => setShowMenu(false)}
        />
      )}
    </>
  );
};

export default RevenueChart;